module.exports = __webpack_public_path__ + "static/media/piccolo.25c7b73d.wav";